(function () {
    var configureReturnData = function (data) {
      if (typeof data != 'object' || data == null ){
        respCallBack(configureExceptionMsg("SDK0200010", "SDKÃ¥â€œÂÃ¥Âºâ€Ã¦â€¢Â°Ã¦ÂÂ®Ã¨Â§Â£Ã¦Å¾ÂÃ¥Â¤Â±Ã¨Â´Â¥"));
        return
      }
      var param = data;
      var paramHead = param["Head"];
      var dataHead = data["Head"];
      if (typeof paramHead == "undefined" || paramHead == null || paramHead == "") {
        paramHead = {
          Rqs_Jrnl_No: "",
          Rsp_Dt: "",
          Rsp_Tm: "",
          Txn_Rsp_Cd_Dsc: "",
          Txn_Rsp_Inf: "",
        };
      }
      if (typeof dataHead == "undefined" || paramHead == null || paramHead == "") {
        dataHead = {};
      }
  
      if ("000000" == paramHead["Txn_Rsp_Cd_Dsc"] || "999999" == paramHead["Txn_Rsp_Cd_Dsc"]) {
        paramHead["Txn_Rsp_Cd_Dsc"] = dataHead["SYS_RESP_CODE"] || "";
        paramHead["Txn_Rsp_Inf"] = dataHead["SYS_RESP_DESC"] || "";
      }
      delete paramHead.SYS_RESP_DESC;
      delete paramHead.SYS_RESP_CODE;
      param["Head"] = paramHead;
      return param;
    };
  
    var configureExceptionMsg = function (errorCode, errorMsg) {
      //Ã©â€¦ÂÃ§Â½Â®Ã¥Â¼â€šÃ¥Â¸Â¸Ã¨Â¿â€Ã¥â€ºÅ¾Ã¤Â¿Â¡Ã¦ÂÂ¯
      var errorPackage = {
        Head: {
          Rqs_Jrnl_No: "",
          Rsp_Dt: "",
          Rsp_Tm: "",
          Txn_Rsp_Cd_Dsc: errorCode || "",
          Txn_Rsp_Inf: errorMsg || "",
        },
        Data: {},
      };
      return errorPackage;
    };
  
    var _ajax = function (conf) {
     
      var url = conf.url;
      var data = conf.data;
      var send_data = [];
      var async = conf.async != undefined ? conf.async : true;
      var type = conf.type || "post";
      var dataType = conf.dataType || "json";
      var contenType = conf.contenType || "application/x-www-form-urlencoded";
      var beforeSend = conf.beforeSend;
      var success = conf.success;
      var error = conf.error;
      if (data == null) {
        send_data = "";
      } else if (typeof data == "object") {
        for (var k in data) {
          send_data.push(encodeURIComponent(k) + "=" + encodeURIComponent(data[k]));
        }
        send_data = send_data.join("&");
      }
      send_data = data;
      var xhr = "";
      try {
        xhr = new ActiveXObject("microsoft.xmlhttp");
      } catch (e1) {
        try {
          xhr = new XMLHttpRequest();
        } catch (e2) {
          if (error != null) {
            error("Ã¦â€šÂ¨Ã§Å¡â€žÃ¦ÂµÂÃ¨Â§Ë†Ã¥â„¢Â¨Ã¤Â¸ÂÃ¦â€Â¯Ã¦Å’ÂajaxÃ¯Â¼ÂÃ¨Â¯Â·Ã¦â€ºÂ´Ã¦ÂÂ¢Ã¯Â¼Â");
          }
        }
      }
  
      if (type == "get") {
        xhr.open(type, url + "?" + send_data, async);
        xhr.timeout = 45000;
        xhr.send(null);
      } else {
        xhr.open(type, url, async);
        xhr.timeout = 45000;
        xhr.setRequestHeader("content-type", contenType);
        if (beforeSend != null && beforeSend != undefined) {
          beforeSend(xhr);
        }
        xhr.send(send_data);
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status >= 200 && xhr.status < 300) {
            if (dataType == "text" && success != null) {
              success(xhr.responseText);
            }
            if (dataType == "xml" && success != null) {
              success(xhr.responseXML);
            }
            if (dataType == "json" && success != null) {
              success(JSON.parse(xhr.responseText));
            }
          } else {
            if (error != null) {
              error("Ã§Â½â€˜Ã§Â»Å“Ã¨Â¿Å¾Ã¦Å½Â¥Ã¥Â¼â€šÃ¥Â¸Â¸Ã¯Â¼Å¡" + xhr.status);
            }
          }
        }
      };
    };
  
    var isInvalid = function (value) {
      return value == null || value == "" || value == "undefined"|| value == "null";
    };
  
    var getUrlParam = function (name, respCallBack) {
      var reg = new RegExp("(^|&)" + name + "=(.*)(&[^&=]+=)");
      var regLast = new RegExp("(^|&)" + name + "=(.*)($)");
      var search = window.location.search.substr(1);
      if (isInvalid(search)) {
        respCallBack(configureExceptionMsg("SDK0100004", "Ã¥Â­â€”Ã¦Â®ÂµÃ¦ Â¡Ã©ÂªÅ’Ã¥Â¼â€šÃ¥Â¸Â¸"));
        return;
      }
      var r = search.match(reg) || search.match(regLast);
      var objReturn;
      if (isInvalid(r)) {
        respCallBack(configureExceptionMsg("SDK0100004", "Ã¥Â­â€”Ã¦Â®ÂµÃ¦ Â¡Ã©ÂªÅ’Ã¥Â¼â€šÃ¥Â¸Â¸"));
        return;
      }
  
      if (isInvalid(r[2])) {
        respCallBack(configureExceptionMsg("SDK0100004", "Ã¥Â­â€”Ã¦Â®ÂµÃ¦ Â¡Ã©ÂªÅ’Ã¥Â¼â€šÃ¥Â¸Â¸"));
        return;
      }
  
      var l = r[2].match(/&[^&=]+=/);
      try {
        if (l) {
          objReturn = decodeURIComponent(r[2].split(l[0])[0]);
        } else {
          objReturn = decodeURIComponent(r[2]);
        }
      } catch (error) {
        respCallBack(configureExceptionMsg("SDK0100001", "SDKÃ¥Ë†ÂÃ¥Â§â€¹Ã¥Å’â€“Ã¥Â¼â€šÃ¥Â¸Â¸"));
        return;
      }
      respCallBack(objReturn);
    };
  
    var timestamp = function () {
      //Ã¦â€”Â¶Ã©â€”Â´Ã¦Ë†Â³
      var tmp = Date.parse(new Date()).toString();
      tmp = tmp.substr(0, 10);
      return tmp;
    };
  
    function randomString(len) {
      //Ã¨Å½Â·Ã¥Ââ€“lenÃ©â€¢Â¿Ã¥ÂºÂ¦Ã§Å¡â€žÃ¥Â¤Â§Ã¥Â°ÂÃ¥â€ â„¢Ã¥Â­â€”Ã¦Â¯ÂÃ¦â€¢Â°Ã¥Â­â€”Ã¥Â­â€”Ã§Â¬Â¦Ã¤Â¸Â²
      len = len || 16;
      var $chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz012345678";
      var maxPos = $chars.length;
      var pwd = "";
      for (var i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    }
    var sixRandom = function () {
      var sixRd = "";
      for (var i = 0; i < 6; i++) {
        var r = Math.floor(Math.random() * 10);
        sixRd += r;
      }
      return sixRd;
    };
    var getProductID = function (obj) {
      var arr = obj.split("/");
      return arr[3];
    };
  
    function getCurrentDate() {
      var now = new Date();
  
      var yy = now.getFullYear(); //Ã¥Â¹Â´
      var mm = now.getMonth() + 1; //Ã¦Å“Ë†
      var dd = now.getDate(); //Ã¦â€”Â¥
      var time = "";
      time += yy;
      if (mm < 10) time += "0";
      time += mm;
      if (dd < 10) time += "0";
      time += dd;
      return time;
    }
    function getCurrentTime() {
      var now = new Date();
  
      var hh = now.getHours(); //Ã¦â€”Â¶
      var ii = now.getMinutes(); //Ã¥Ë†â€ 
      var ss = now.getSeconds(); //Ã§Â§â€™
      var time = "";
      if (hh < 10) time += "0";
      time += hh;
      if (ii < 10) time += "0";
      time += ii;
      if (ss < 10) time += "0";
      time += ss;
      return time;
    }
  
    var configureRequestHead = function (customHeader) {
      var HeadTemp = customHeader;
      var SDKHeader = {
        APP_Key: sessionStorage.getItem("appkey"),
        APP_Token: sessionStorage.getItem("Token"),
        IP_Adr: sessionStorage.getItem("IP"),
        Txn_ModDsc: "h5",
        SDK_VNo: "JS-SDK-1.0.3",
        Rqs_Dt: getCurrentDate(),
        Rqs_Tm: getCurrentTime(),
      };
  
      for (var item in SDKHeader) {
        HeadTemp[item] = SDKHeader[item];
      }
      return HeadTemp;
    };
  
    var publickey = "";
    var URL_base = "";
    var hostNamed = window.location.hostname;
    if (hostNamed == "sandbox.open.ccb.com") {
      URL_base = "https://sandbox.open.ccb.com";
      publickey =
        "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAjVdGe8P2JumYU4sB1Zywioxw1+HaZB/KmzrzlClj2m2e4ZPqS5cYe2FCiCwBmyizZrVYGfECugszj7e+OjbrFeqOpCgOYnXrbX0me0YdqLAowELbI4cqRxGciFlbgkjJXLoTHX/ZPPKAaF8VCNfQJrfpAqYZBeGPHWiODu4m3P8lGG5U+kHsjemdFf+5iwBabtm8IKvvE3fIfboXjnsdLSW3xxWjFK2A7iubUA8U0jA9UCCJp61qDnjmMC4hfW5QEWQMchW2D6vRYyZZStKGYxKto60jj5qnqm0+xyX9X5pBz9hTWTIqCHpzbyeLTOeG3l2jQ4ut9ZgVXP9IRj1IzwIDAQAB";
    } else if (hostNamed == "128.196.238.4") {
      URL_base = "http://128.196.238.4:16612";
      publickey =
        "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAjVdGe8P2JumYU4sB1Zywioxw1+HaZB/KmzrzlClj2m2e4ZPqS5cYe2FCiCwBmyizZrVYGfECugszj7e+OjbrFeqOpCgOYnXrbX0me0YdqLAowELbI4cqRxGciFlbgkjJXLoTHX/ZPPKAaF8VCNfQJrfpAqYZBeGPHWiODu4m3P8lGG5U+kHsjemdFf+5iwBabtm8IKvvE3fIfboXjnsdLSW3xxWjFK2A7iubUA8U0jA9UCCJp61qDnjmMC4hfW5QEWQMchW2D6vRYyZZStKGYxKto60jj5qnqm0+xyX9X5pBz9hTWTIqCHpzbyeLTOeG3l2jQ4ut9ZgVXP9IRj1IzwIDAQAB";
    } else if (hostNamed == "128.196.200.30") {
      URL_base = "https://128.196.200.30";
      publickey =
        "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAjVdGe8P2JumYU4sB1Zywioxw1+HaZB/KmzrzlClj2m2e4ZPqS5cYe2FCiCwBmyizZrVYGfECugszj7e+OjbrFeqOpCgOYnXrbX0me0YdqLAowELbI4cqRxGciFlbgkjJXLoTHX/ZPPKAaF8VCNfQJrfpAqYZBeGPHWiODu4m3P8lGG5U+kHsjemdFf+5iwBabtm8IKvvE3fIfboXjnsdLSW3xxWjFK2A7iubUA8U0jA9UCCJp61qDnjmMC4hfW5QEWQMchW2D6vRYyZZStKGYxKto60jj5qnqm0+xyX9X5pBz9hTWTIqCHpzbyeLTOeG3l2jQ4ut9ZgVXP9IRj1IzwIDAQAB";
    } else {
      URL_base = "https://open.ccb.com";
      publickey =
        "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAgQ6fYsQ+KBx4wVGbsGV1uaCLpZaLMUZRoawliWrUsW59DbIRhq600LOsV5/ogW7M4ZM9wEu2mXyPVP+QOgu1a0liCxfyvpue4F10TDBmCRO3OAE8rq3TkHS+cl1Q1XUSUkzr8jXLesEcaUZY91EUCI6PfAi9B9IRmPN6zB4kNw+6oLoJXAcr/vMOkWlFBchWRKa1PCYVTVEGEKiiHURfPan7VJ1KvlLmp5IPquF58OfspZWlAxrcZWDCqYnywuPhyF3s3kF3pKV4vF6LReVwA1VmZjP86PwvKn3BuEnie0PD79rws1IkIGclXR6MSFgIhLaLQFLNS/unSYADm/jQ2QIDAQAB";
    }
    // sessionStorage.setItem("urlBaseString", URL_base);
    // sessionStorage.setItem("sPublicKey", publickey);
    var networkWithURLAndParam = function (url, param, respCallBack) {
      //Ã¥Â°ÂÃ¨Â£â€¦Ã§Å¡â€žÃ¤Â¸Å¡Ã¥Å Â¡Ã¯Â¼Ë†JS-SDKÃ¯Â¼â€°Ã§Â½â€˜Ã§Â»Å“Ã¨Â¯Â·Ã¦Â±â€š
      var appkey = sessionStorage.getItem("appkey")
      if (appkey == null || typeof appkey == "undefined") {
        respCallBack(configureExceptionMsg("SDK0100001", "SDKÃ¥Ë†ÂÃ¥Â§â€¹Ã¥Å’â€“Ã¥Â¼â€šÃ¥Â¸Â¸"));
        return;
      }
      var MixTraceId = "908056" + appkey.substring(0, 3) + timestamp() + sixRandom();
      var result;
      _ajax({
        url: url,
        type: "POST",
        data: JSON.stringify(param),
        async: true,
        beforeSend: function (XMLHttpRequest) {
          XMLHttpRequest.setRequestHeader("MAC_Adr", ""); //jsÃ¤Â¸ÂÃ¦â€Â¯Ã¦Å’ÂÃ¨Å½Â·Ã¥Ââ€“Ã¨Â®Â¾Ã¥Â¤â€¡ID
          XMLHttpRequest.setRequestHeader("APP_Token", sessionStorage.getItem("Token") || "");
          XMLHttpRequest.setRequestHeader("Txn_ModDsc", "h5");
          XMLHttpRequest.setRequestHeader("APP_Key", sessionStorage.getItem("appkey"));
          XMLHttpRequest.setRequestHeader("IP_Adr", sessionStorage.getItem("IP"));
          XMLHttpRequest.setRequestHeader("Eqmt_ID_No", ""); //jsÃ¤Â¸ÂÃ¦â€Â¯Ã¦Å’ÂÃ¨Å½Â·Ã¥Ââ€“Ã¨Â®Â¾Ã¥Â¤â€¡ID
          XMLHttpRequest.setRequestHeader("Sys_Evt_Trace_Id", MixTraceId);
          XMLHttpRequest.setRequestHeader("ProductID", getProductID(window.location.pathname));
        },
        dataType: "json",
        success: function (data) {
          respCallBack(data);
        },
        error: function (data) {
          result = configureExceptionMsg("SDK0000009", "Ã§Â½â€˜Ã§Â»Å“Ã¨Â¿Å¾Ã¦Å½Â¥Ã¥Â¼â€šÃ¥Â¸Â¸");
          respCallBack(result);
        },
      });
    };
  
    var CCBSDK = (function () {
      var approveDeveloper = function (respCallBack) {
        //Ã¨Â§Â£Ã¦Å¾ÂURLÃ¤Â¸Â­Ã¤Â¼ Ã©â‚¬â€™Ã¨Â¿â€¡Ã¦ÂÂ¥Ã§Å¡â€žÃ¥â‚¬Â¼
        var ScrtSgn;
        getUrlParam("sgn", function (r_data) {
          if (typeof r_data == "string" && r_data != "") {
            ScrtSgn = r_data;
          } else {
            respCallBack(r_data);
            return;
          }
        });
        var ScrtData;
        getUrlParam("data", function (r_data) {
          if (typeof r_data == "string" && r_data != "") {
            ScrtData = r_data;
          } else {
            respCallBack(r_data);
            return;
          }
        });
        var currentEnv;
        getUrlParam("env", function (r_data) {
          if (typeof r_data == "string" && r_data != "") {
            currentEnv = r_data;
          }
        });
  
        var urlBaseStringRead = sessionStorage.getItem("urlBaseString");
        if (
          urlBaseStringRead == "https://sandbox.open.ccb.com" &&
          currentEnv != "" &&
          currentEnv != null &&
          currentEnv != "undefined" &&
          currentEnv.length > 0
        ) {
          urlBaseStringRead = urlBaseStringRead + "/api/" + currentEnv + "/h5";
        } else {
          urlBaseStringRead = urlBaseStringRead + "/api/h5";
        }

        // sessionStorage.setItem("urlBaseString", urlBaseStringRead);

        try {
          var result2 = CryptoJS.enc.Base64.parse(ScrtData).toString(CryptoJS.enc.Utf8);
          var arr = result2.split("|");
        
          // sessionStorage.setItem("appkey", arr[0]);
          // sessionStorage.setItem("IP", arr[3]);
  
          var synckey = randomString();
          var AESData = getAesString(result2, synckey);
          var RSAData = getRsaString(synckey, sessionStorage.getItem("sPublicKey"));
        } catch (error) {
          respCallBack(configureExceptionMsg("SDK0100002", "SDKÃ¨Â¯Â·Ã¦Â±â€šJSONÃ¦Å¾â€žÃ¥Â»ÂºÃ¥Â¤Â±Ã¨Â´Â¥"));
          return;
        }
  
        var url = sessionStorage.getItem("urlBaseString") + "/approveDev";
        var requestData = {
          ScrtSgn: ScrtSgn,
          ScrtData: AESData,
          ScrtKey: RSAData,
        };
        networkWithURLAndParam(url, requestData, function (data) {
          if (data.ScrtKey) {
            try {
              var scrtkey = getDeAesString(data.ScrtKey, synckey);
              var sgn = getDeAesString(data.ScrtSgn, scrtkey);
              var JSON_Data = JSON.parse(getDeAesString(data.ScrtData, scrtkey));
  
            
              // sessionStorage.setItem("randomkey", scrtkey);
              var createSgn = CryptoJS.enc.Base64.stringify(CryptoJS.SHA256(JSON.stringify(JSON_Data)));
              if (createSgn == sgn) {
                // sessionStorage.setItem("Token", JSON_Data.Data.APP_Token);
                // sessionStorage.setItem("Async_Key", JSON_Data.Data.Async_Key);
               
                JSON_Data.Data = {};
                if (JSON_Data.Head.SYS_RESP_CODE == "000000") {
                  JSON_Data.Head.SYS_RESP_CODE = "000000000000";
                }
                respCallBack(configureReturnData(JSON_Data));
              } else {
                respCallBack(configureExceptionMsg("SDK0200011", "SDKÃ©ÂªÅ’Ã§Â­Â¾Ã¥Â¤Â±Ã¨Â´Â¥"));
              }
            } catch (error) {
              respCallBack(configureExceptionMsg("SDK0200010", "SDKÃ¥â€œÂÃ¥Âºâ€Ã¦â€¢Â°Ã¦ÂÂ®Ã¨Â§Â£Ã¦Å¾ÂÃ¥Â¤Â±Ã¨Â´Â¥"));
              return;
            }
          } else if (data.Head) {
            respCallBack(configureReturnData(data));
          } else {
            respCallBack(configureExceptionMsg("SDK0100005", "Ã¥Â¼â‚¬Ã¥Ââ€˜Ã¨â‚¬â€¦Ã¨Â®Â¤Ã¨Â¯ÂÃ¥Â¤Â±Ã¨Â´Â¥"));
          }
        });
      };
      var ajaxSend = function (url, rq_Head, rq_Data, respCallBack) {
        var gettoken = sessionStorage.getItem("Token");
        if (gettoken == "" || gettoken == null || gettoken == "undefined") {
          respCallBack(configureExceptionMsg("SDK0000007", "tokenÃ¨Â®Â¤Ã¨Â¯ÂÃ¥Â¤Â±Ã¨Â´Â¥"));
          return;
        } else {
          var ajaxUrl = sessionStorage.getItem("urlBaseString") + url;
          var ajaxData = {
            Head: configureRequestHead(rq_Head),
            Data: rq_Data,
          };
          ajaxData = JSON.stringify(ajaxData);
          try {
            var ScData = getAesString(ajaxData, sessionStorage.getItem("Async_Key"));
            var ScSgn = CryptoJS.SHA256(ajaxData);
            var NewajaxData = {
              ScrtSgn: getAesString(CryptoJS.enc.Base64.stringify(ScSgn), sessionStorage.getItem("Async_Key")),
              ScrtData: ScData,
            };
          } catch (error) {
            respCallBack(configureExceptionMsg("SDK0100002", "SDKÃ¨Â¯Â·Ã¦Â±â€šJSONÃ¦Å¾â€žÃ¥Â»ÂºÃ¥Â¤Â±Ã¨Â´Â¥"));
            return;
          }
          networkWithURLAndParam(ajaxUrl, NewajaxData, function (data) {
            if (data.ScrtData) {
              try {
                var scrtkey = sessionStorage.getItem("Async_Key");
                var JSON_Data = JSON.parse(getDeAesString(data.ScrtData, scrtkey));
                var JSON_Sgn = getDeAesString(data.ScrtSgn, scrtkey);
                var createData = CryptoJS.enc.Base64.stringify(CryptoJS.SHA256(JSON.stringify(JSON_Data)));
                if (createData == JSON_Sgn) {
                  respCallBack(configureReturnData(JSON_Data));
                } else {
                  respCallBack(configureExceptionMsg("SDK0200011", "SDKÃ©ÂªÅ’Ã§Â­Â¾Ã¥Â¤Â±Ã¨Â´Â¥"));
                }
              } catch (error) {
                respCallBack(configureExceptionMsg("SDK0200010", "SDKÃ¥â€œÂÃ¥Âºâ€Ã¦â€¢Â°Ã¦ÂÂ®Ã¨Â§Â£Ã¦Å¾ÂÃ¥Â¤Â±Ã¨Â´Â¥"));
              }
            } else if (data.Head) {
              respCallBack(configureReturnData(data));
            } else {
              respCallBack(configureReturnData(data));
            }
          });
        }
      };
      function z() {
        z.prototype.init = function () {
          return new Promise(function (resolve, reject) {
            approveDeveloper(function (resp) {
              resolve(resp);
            });
          });
        };
        z.prototype.send = function (url, rq_Head, rq_Data) {
          return new Promise(function (resolve, reject) {
            ajaxSend(url, rq_Head, rq_Data, function (resp) {
              resolve(resp);
            });
          });
        };
      }
      return new z();
    })();
    window.CCBSDK = CCBSDK;
  })();